export default [
  {
    name: 'Australian Dollar',
    code: 'aud',
    minAmount: 35,
    icon: 'https://static.moonpay.com/widget/currencies/aud.svg'
  },
  {
    name: 'Bulgarian Lev',
    code: 'bgn',
    minAmount: 40,
    icon: 'https://static.moonpay.com/widget/currencies/bgn.svg'
  },
  {
    name: 'Brazilian Real',
    code: 'brl',
    minAmount: 130,
    icon: 'https://static.moonpay.com/widget/currencies/brl.svg'
  },
  {
    name: 'Canadian Dollar',
    code: 'cad',
    minAmount: 30,
    icon: 'https://static.moonpay.com/widget/currencies/cad.svg'
  },
  {
    name: 'Swiss Franc',
    code: 'chf',
    minAmount: 20,
    icon: 'https://static.moonpay.com/widget/currencies/chf.svg'
  },
  {
    name: 'Colombian Peso',
    code: 'cop',
    minAmount: 100000,
    icon: 'https://static.moonpay.com/widget/currencies/cop.svg'
  },
  {
    name: 'Czech Koruna',
    code: 'czk',
    minAmount: 500,
    icon: 'https://static.moonpay.com/widget/currencies/czk.svg'
  },
  {
    name: 'Danish Krone',
    code: 'dkk',
    minAmount: 150,
    icon: 'https://static.moonpay.com/widget/currencies/dkk.svg'
  },
  {
    name: 'Dominican Peso',
    code: 'dop',
    minAmount: 1500,
    icon: 'https://static.moonpay.com/widget/currencies/dop.svg'
  },
  {
    name: 'Egyptian Pound',
    code: 'egp',
    minAmount: 1000,
    icon: 'https://static.moonpay.com/widget/currencies/egp.svg'
  },
  {
    name: 'Euro',
    code: 'eur',
    minAmount: 20,
    icon: 'https://static.moonpay.com/widget/currencies/eur.svg'
  },
  {
    name: 'Pound Sterling',
    code: 'gbp',
    minAmount: 20,
    icon: 'https://static.moonpay.com/widget/currencies/gbp.svg'
  },
  {
    name: 'Hong Kong Dollar',
    code: 'hkd',
    minAmount: 175,
    icon: 'https://static.moonpay.com/widget/currencies/hkd.svg'
  },
  {
    name: 'Indonesian Rupiah',
    code: 'idr',
    minAmount: 400000,
    icon: 'https://static.moonpay.com/widget/currencies/idr.svg'
  },
  {
    name: 'Israeli New Shekel',
    code: 'ils',
    minAmount: 75,
    icon: 'https://static.moonpay.com/widget/currencies/ils.svg'
  },
  {
    name: 'Jordanian Dinar',
    code: 'jod',
    minAmount: 15,
    icon: 'https://static.moonpay.com/widget/currencies/jod.svg'
  },
  {
    name: 'Kenyan Shilling',
    code: 'kes',
    minAmount: 3000,
    icon: 'https://static.moonpay.com/widget/currencies/kes.svg'
  },
  {
    name: 'Kuwaiti Dinar',
    code: 'kwd',
    minAmount: 8,
    icon: 'https://static.moonpay.com/widget/currencies/kwd.svg'
  },
  {
    name: 'Sri Lankan Rupee',
    code: 'lkr',
    minAmount: 7000,
    icon: 'https://static.moonpay.com/widget/currencies/lkr.svg'
  },
  {
    name: 'Mexican Peso',
    code: 'mxn',
    minAmount: 450,
    icon: 'https://static.moonpay.com/widget/currencies/mxn.svg'
  },
  {
    name: 'Nigerian Naira',
    code: 'ngn',
    minAmount: 20000,
    icon: 'https://static.moonpay.com/widget/currencies/ngn.svg'
  },
  {
    name: 'Norwegian Krone',
    code: 'nok',
    minAmount: 250,
    icon: 'https://static.moonpay.com/widget/currencies/nok.svg'
  },
  {
    name: 'New Zealand Dollar',
    code: 'nzd',
    minAmount: 35,
    icon: 'https://static.moonpay.com/widget/currencies/nzd.svg'
  },
  {
    name: 'Omani Rial',
    code: 'omr',
    minAmount: 10,
    icon: 'https://static.moonpay.com/widget/currencies/omr.svg'
  },
  {
    name: 'Peruvian Sol',
    code: 'pen',
    minAmount: 80,
    icon: 'https://static.moonpay.com/widget/currencies/pen.svg'
  },
  {
    name: 'Polish Złoty',
    code: 'pln',
    minAmount: 90,
    icon: 'https://static.moonpay.com/widget/currencies/pln.svg'
  },
  {
    name: 'Romanian Leu',
    code: 'ron',
    minAmount: 100,
    icon: 'https://static.moonpay.com/widget/currencies/ron.svg'
  },
  {
    name: 'Swedish Krona',
    code: 'sek',
    minAmount: 250,
    icon: 'https://static.moonpay.com/widget/currencies/sek.svg'
  },
  {
    name: 'Thai Baht',
    code: 'thb',
    minAmount: 800,
    icon: 'https://static.moonpay.com/widget/currencies/thb.svg'
  },
  {
    name: 'Turkish Lira',
    code: 'try',
    minAmount: 700,
    icon: 'https://static.moonpay.com/widget/currencies/try.svg'
  },
  {
    name: 'Taiwan Dollar',
    code: 'twd',
    minAmount: 750,
    icon: 'https://static.moonpay.com/widget/currencies/twd.svg'
  },
  {
    name: 'US Dollar',
    code: 'usd',
    minAmount: 20,
    icon: 'https://static.moonpay.com/widget/currencies/usd.svg'
  },
  {
    name: 'Vietnamese Dong',
    code: 'vnd',
    minAmount: 600000,
    icon: 'https://static.moonpay.com/widget/currencies/vnd.svg'
  },
  {
    name: 'South African Rand',
    code: 'zar',
    minAmount: 400,
    icon: 'https://static.moonpay.com/widget/currencies/zar.svg'
  }
]
